import { PinIcon } from "@/components/shared/icons"
import UserCreated from "@/components/Explore/Gallery/UserCreated"
import { memo } from "react"

interface WorkflowItemHeaderProps {
  name: string
  isPinned?: boolean
  creator?: {
    name: string
    picture: string
  }
  hiddenCreator?: boolean
}

const WorkflowItemHeader = ({ name, isPinned, creator, hiddenCreator }: WorkflowItemHeaderProps) => {
  return (
    <div className="p-2">
      <div className="flex overflow-hidden">
        <p className="flex-1 line-clamp-1 font-semibold break-all text-sm">{name}</p>
        {isPinned && (
          <div className="p-0.5">
            <PinIcon width={16} height={16} />
          </div>
        )}
      </div>
      {!hiddenCreator && creator && (
        <UserCreated className="mt-1" size="xs" name={creator.name} picture={creator.picture} />
      )}
    </div>
  )
}

WorkflowItemHeader.displayName = "WorkflowItemHeader"

export default memo(WorkflowItemHeader, (prevProps, nextProps) => {
  if (prevProps.name === nextProps.name) return true
  if (prevProps.creator?.name === nextProps.creator?.name) return true
  if (prevProps.creator?.picture === nextProps.creator?.picture) return true
  if (prevProps.isPinned === nextProps.isPinned) return true

  return false
})
